import { PrimaryButton, CheckCircleIcon } from 'ia-react-core';
import styled from 'styled-components';

export const StyledMainDivForm = styled.div`
  height: 633px;
  margin: 98px 0px 151px 0px;
`;

export const StyledImageSuccess = styled(CheckCircleIcon)`
  color: ${({ theme }) => theme.colors.green10};
  width: 84px;
  height: 84px;
  margin: 0 auto 24px auto;
  display: block;
  object-fit: contain;
`;

export const StyledConfirmationLine1 = styled.div`
  height: 28px;
  margin: 24px 0;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;

  @media only screen and (max-width: 600px) {
    margin-bottom: 45px;
  }
`;

export const StyledConfirmationLine2 = styled.div`
  height: 22px;
  margin: 24px 0 30px;
  font-family: ${({ theme }) => theme?.fontFamily?.regular};
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: var(--type-main);
`;

export const StyledConfirmButton = styled(PrimaryButton)`
  width: 100%;
  text-align:center;

  &:focus {
    box-shadow: none;
  }
`;
